import type { Metadata } from '@mint-sdk/api-mdm';

/** MDM's platform display shape — `value` is the `platform_v2` URN, `label`/`iconUrl` drive presentation. */
export type ConnectionPlatformDisplay = Metadata.MdmPlatformFieldValueType;

/** The manage page's ad-accounts tabs — mirrors `AdAccountView` in `packages/connections/src/types/common.ts`. */
export const AdAccountView = {
  available: 'available',
  connected: 'connected',
} as const;
